import React from "react";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { TrackedObjChange } from "../interfaces/ChangesTracker";

export const PILL_BASE_STYLE: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "2px 16px",
  borderRadius: "4px",
  height: "18px",
  lineHeight: "18px",
  fontSize: "12px",
  fontWeight: 600,
  color: "white",
  userSelect: "none",
  verticalAlign: "middle",
  maxWidth: 200,
  overflow: "hidden"
};

export const getStatusColor = (trackedChange: TrackedObjChange) => {
  const type = trackedChange.userAction ?? trackedChange.status;

  if (type === "ADD") return "var(--color-blue)";
  if (type === "CREATE") return "var(--color-blue)";
  if (type === "EDIT") return "var(--color-yellow)";
  if (type === "UPDATE") return "var(--color-green)";
  if (type === "DELETE") return "var(--color-red)";
  if (type === "RESTORE") return "var(--color-blue)";
  return "red";
};

export const getStatusLabel = (trackedChange: TrackedObjChange) => {
  const t = trackedChange.userAction ?? trackedChange.status;

  if (t === "ADD") return formatMessage("cof.objectlist.changetracker.status.add");
  if (t === "CREATE") return formatMessage("cof.objectlist.changetracker.status.add");
  if (t === "EDIT") return formatMessage("cof.objectlist.changetracker.status.edit");
  if (t === "UPDATE") return formatMessage("cof.objectlist.changetracker.status.update");
  if (t === "DELETE") return formatMessage("cof.objectlist.changetracker.status.delete");
  if (t === "RESTORE") return formatMessage("cof.objectlist.changetracker.status.restore");

  return "unknown";
};

export const CustomPill = (
  props: React.HTMLAttributes<HTMLSpanElement> & { color: string }
) => {
  return (
    <span
      {...props}
      style={{
        ...PILL_BASE_STYLE,
        backgroundColor: props.color,
        ...props.style
      }}
    />
  );
};

export const TrackedChangeOperationTypePill = ({
                                                 trackedChange
                                               }: {
  trackedChange: TrackedObjChange;
}) => {
  return (
    <CustomPill color={getStatusColor(trackedChange)}>
      {getStatusLabel(trackedChange).toUpperCase()}
    </CustomPill>
  );
};
